import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import 'vue3-carousel/dist/carousel.css';
import { Carousel, Navigation, Slide } from 'vue3-carousel';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseButtonsCarousel',
  props: {
    btns: {}
  },
  setup(__props: any) {

const props = __props;

const settings = {
  itemsToShow: 1,
  snapAlign: 'center',
};
const breakpoints = {
  600: {
    itemsToShow: 2,
    snapAlign: 'center',
  },
  960: {
    itemsToShow: 3,
    snapAlign: 'center',
  },
  1000: {
    itemsToShow: 4,
    snapAlign: 'center',
  },
  1264: {
    itemsToShow: 5,
    snapAlign: 'start',
  },
};

return (_ctx: any,_cache: any) => {
  const _component_base_button = _resolveComponent("base-button")!

  return (_openBlock(), _createBlock(_unref(Carousel), { breakpoints: breakpoints }, {
    addons: _withCtx(() => [
      _createVNode(_unref(Navigation))
    ]),
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.btns, (slide) => {
        return (_openBlock(), _createBlock(_unref(Slide), { key: slide }, {
          default: _withCtx(() => [
            _createVNode(_component_base_button, {
              text: slide,
              "all-block-width": "",
              height: "36",
              "style-type": "grey"
            }, null, 8, ["text"])
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _: 1
  }))
}
}

})